"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NewsFeedModal = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const moment_1 = __importDefault(require("moment"));
const react_1 = __importStar(require("react"));
const react_hook_form_1 = require("react-hook-form");
const load_shifts_1 = __importDefault(require("@app/ac/load-shifts"));
const set_news_feed_1 = require("@app/ac/set-news-feed");
const allowed_file_types_1 = require("@app/const/allowed-file-types");
const globals_1 = require("@app/const/globals");
const request_1 = require("@app/request");
const query_1 = require("@app/request/query");
const store_1 = require("@app/store");
const util_1 = require("@app/util");
const apollo_1 = require("@app/util/apollo");
const error_handler_1 = require("@app/util/error-handler");
const mappers_1 = require("@app/util/mappers");
const upload_file_1 = require("@app/util/upload-file");
const manipulations_1 = require("@core/manipulations");
const _ui_1 = require("@ui");
const maybe_unwrap_1 = require("@app/util/apollo/maybe-unwrap");
const constants_1 = require("./constants");
require("./index.scss");
const FEED_ITEM_CREATE_MUTATION = (0, graphql_tag_1.default) `
  ${query_1.FEED_ITEM_CREATE}
`;
const FEED_ITEM_UPDATE_MUTATION = (0, graphql_tag_1.default) `
  ${query_1.FEED_ITEM_UPDATE}
`;
const FEED_ITEM_DELETE_MUTATION = (0, graphql_tag_1.default) `
  ${query_1.FEED_ITEM_DELETE}
`;
const NewsFeedModal = ({ close, updateQuery, subject: initialSubject, text: initialText, readRequire, pinned, itemUpdateId, attachments: existingAttachments, }) => {
    const dispatch = (0, store_1.useRootDispatch)();
    const auth = (0, store_1.useRootSelector)((state) => state.auth);
    const employees = (0, store_1.useRootSelector)((state) => state.employees);
    const workspaceId = (0, store_1.useRootSelector)((state) => state.workspaceId);
    const positions = (0, store_1.useRootSelector)((state) => state.positions);
    const workspaces = (0, store_1.useRootSelector)((state) => state.workspaces);
    const shifts = (0, store_1.useRootSelector)((state) => state.shifts);
    const me = (0, store_1.useRootSelector)((state) => state.me);
    const [files, setFiles] = (0, react_1.useState)([]);
    const [submitting, setSubmitting] = (0, react_1.useState)(false);
    const { control, handleSubmit, watch } = (0, react_hook_form_1.useForm)({
        defaultValues: {
            [constants_1.SUBJECT]: initialSubject ?? '',
            [constants_1.TEXT]: initialText ?? '',
            [constants_1.AUDIENCE_BY]: '',
            [constants_1.REQUIRE_CONFIRMATION]: !!readRequire,
            [constants_1.PIN_A_MESSAGE]: !!pinned,
            [constants_1.CHECKED_ITEMS]: [],
        },
    });
    react_1.default.useEffect(() => {
        dispatch((0, load_shifts_1.default)({
            period: {
                start: (0, moment_1.default)().startOf('year'),
                end: (0, moment_1.default)().add(12, 'month').endOf('day'),
            },
            users: null,
            warningsHidden: true,
        }));
    }, [dispatch]);
    const audienceBy = watch(constants_1.AUDIENCE_BY);
    const checkedItems = watch(constants_1.CHECKED_ITEMS);
    const audienceByCtrl = (0, react_hook_form_1.useController)({ control, name: constants_1.AUDIENCE_BY });
    const checkedItemsCtrl = (0, react_hook_form_1.useController)({ control, name: constants_1.CHECKED_ITEMS });
    const requireConfirmationCtrl = (0, react_hook_form_1.useController)({
        control,
        name: constants_1.REQUIRE_CONFIRMATION,
    });
    const pinAMessageCtrl = (0, react_hook_form_1.useController)({ control, name: constants_1.PIN_A_MESSAGE });
    const subjectCtrl = (0, react_hook_form_1.useController)({ control, name: constants_1.SUBJECT });
    const textCtrl = (0, react_hook_form_1.useController)({ control, name: constants_1.TEXT });
    const receiversMapper = (args) => {
        switch (args.audienceBy) {
            case globals_1.GLOBAL_DATEPICKER:
                return (0, mappers_1.DatePickerMapper)(args.values, shifts);
            case globals_1.GLOBAL_SINGLE_PERSON:
                return (0, mappers_1.SinglePersonMapper)(args.values);
            case globals_1.GLOBAL_ALL_USERS:
                return (0, mappers_1.EmployeesMapper)(employees);
            case globals_1.GLOBAL_LOCALITY:
                return (0, mappers_1.LocalitiesMapper)(args.values, workspaces);
            default:
                return [];
        }
    };
    const onSubmit = async (formValues) => {
        const { [constants_1.REQUIRE_CONFIRMATION]: requireConfirmation, [constants_1.CHECKED_ITEMS]: checkedItemsVal, [constants_1.AUDIENCE_BY]: audienceByVal, } = formValues;
        const loadHidden = async () => {
            const result = await (0, request_1.requestEmployees)({ id: workspaceId }, auth);
            if ((0, util_1.isValue)(result?.members)) {
                return (result.members
                    .filter((m) => m.roles?.some((r) => r.hidden))
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    .map((m) => util_1.miscUtil.getEmployeeObjectForStore(m.user, m.roles[0])));
            }
            return [];
        };
        const allEmps = { ...employees };
        const hiddenEmps = await loadHidden();
        hiddenEmps.forEach((he) => {
            if (!Object.keys(allEmps).includes(he.id))
                allEmps[he.id] = he;
        });
        let trgs = audienceByVal === globals_1.GLOBAL_POSITION
            ? Object.values(employees)
                .filter((ee) => !ee.external &&
                ee?.positions?.some((p) => checkedItemsVal.some((ci) => ci.id === p.id)))
                .map((ee) => ({ userId: ee.id }))
            : receiversMapper({
                audienceBy: audienceByVal,
                values: checkedItemsVal,
            }).filter((item) => !item.external && item.userId !== me?.id);
        if (audienceByVal === globals_1.GLOBAL_DATEPICKER && checkedItemsVal) {
            trgs = checkedItemsVal;
        }
        const createVariables = {
            ...formValues,
            workSpaceId: workspaceId,
            targets: trgs.map((item) => ({
                userId: item.userId,
                readRequire: requireConfirmation,
            })),
        };
        const updateVariables = {
            ...formValues,
            workSpaceId: workspaceId,
            id: itemUpdateId,
        };
        try {
            setSubmitting(true);
            if (!updateQuery) {
                let attachmentIds = [];
                if (files.length) {
                    const uploaded = await (0, upload_file_1.uploadFile)(files, workspaceId, auth);
                    attachmentIds = uploaded.map((f) => f.id);
                }
                const { data, errors } = await (0, apollo_1.mutate)(FEED_ITEM_CREATE_MUTATION, { variables: { ...createVariables, attachments: attachmentIds } });
                (0, error_handler_1.processErrors)(errors);
                if ((0, util_1.isValue)(data)) {
                    dispatch((0, set_news_feed_1.AddFeed)(data.feedItemCreate));
                }
                close?.();
            }
            else {
                const existingIds = existingAttachments?.map((a) => a.file.id) ?? [];
                let attachmentIds = existingIds;
                if (files.length) {
                    const uploaded = await (0, upload_file_1.uploadFile)(files, workspaceId, auth);
                    attachmentIds = [...uploaded.map((f) => f.id), ...existingIds];
                }
                const { data, errors } = await (0, apollo_1.mutate)(FEED_ITEM_UPDATE_MUTATION, { variables: { ...updateVariables, attachments: attachmentIds } });
                (0, error_handler_1.processErrors)(errors);
                if ((0, util_1.isValue)(data)) {
                    dispatch((0, set_news_feed_1.UpdateFeed)(data.feedItemUpdate));
                }
                close?.();
            }
        }
        finally {
            setSubmitting(false);
        }
    };
    const optsAudienceBy = [
        { value: globals_1.GLOBAL_SINGLE_PERSON, label: (0, util_1.t)('NF_MAN') },
        { value: globals_1.GLOBAL_POSITION, label: (0, util_1.t)('GLOBAL_POSITION') },
        { value: globals_1.GLOBAL_DATEPICKER, label: (0, util_1.t)('NF_BY_DAY') },
        ...(workspaces.find((w) => w.id === workspaceId)?.localities?.filter(util_1.isValue)
            .length
            ? [{ value: globals_1.GLOBAL_LOCALITY, label: (0, util_1.t)('NF_LOCATION') }]
            : []),
        { value: globals_1.GLOBAL_ALL_USERS, label: (0, util_1.t)('NF_WHOLE_COMPANY') },
    ];
    let optsCheckedItems = [];
    if (audienceBy === globals_1.GLOBAL_SINGLE_PERSON) {
        optsCheckedItems = util_1.sortUtil
            .sortEmployees(employees)
            .map((emp) => ({
            value: emp.id,
            label: emp.name,
            id: emp.id,
        }));
    }
    else if (audienceBy === globals_1.GLOBAL_POSITION) {
        optsCheckedItems = positions
            .filter((p) => !p.archived)
            .map((p) => ({ value: p.id, label: p.name ?? '', id: p.id }));
    }
    else if (audienceBy === globals_1.GLOBAL_LOCALITY) {
        const ws = workspaces.find((w) => w.id === workspaceId);
        if ((0, util_1.isValue)(ws)) {
            optsCheckedItems = (ws.localities ?? [])
                .filter(util_1.isValue)
                .map((l) => ({ value: l.id ?? '', label: l.name ?? '', id: l.id ?? '' }));
        }
    }
    const checkedItemsPlaceholder = audienceBy === globals_1.GLOBAL_POSITION
        ? (0, util_1.t)('NF_SELECT_POSITION')
        : audienceBy === globals_1.GLOBAL_LOCALITY
            ? (0, util_1.t)('NF_SELECT_LOCALITY')
            : (0, util_1.t)('NF_ASSIGN_PEOPLE');
    const isAddDisabled = submitting ||
        !subjectCtrl.field.value ||
        !textCtrl.field.value ||
        !(updateQuery ||
            checkedItems.length > 0 ||
            audienceBy === globals_1.GLOBAL_DATEPICKER ||
            audienceBy === globals_1.GLOBAL_ALL_USERS);
    const onDelete = async () => {
        if (!(0, util_1.isValue)(itemUpdateId))
            return;
        try {
            setSubmitting(true);
            const { data, errors } = await (0, apollo_1.mutate)(FEED_ITEM_DELETE_MUTATION, { variables: { workSpaceId: workspaceId, id: itemUpdateId } });
            (0, error_handler_1.processErrors)(errors);
            if ((0, util_1.isValue)(data)) {
                dispatch((0, set_news_feed_1.DeleteFeed)(itemUpdateId));
            }
            close?.();
        }
        finally {
            setSubmitting(false);
        }
    };
    return (react_1.default.createElement(_ui_1.Modal, { className: 'ds-news-feed-modal', size: _ui_1.Modal.SIZES.L, headerContent: react_1.default.createElement("div", { className: 'ds-title' }, updateQuery
            ? (0, util_1.t)('EDITING_X', { x: initialSubject ?? '' })
            : (0, util_1.t)('NF_CREATE')), extraHeaderButtons: updateQuery
            ? [
                react_1.default.createElement(_ui_1.Icon, { key: 'delete', ico: _ui_1.Icon.ICONS.delete, size: _ui_1.Icon.SIZES.SMALL, color: _ui_1.Icon.COLORS.RED, onClick: onDelete }),
            ]
            : [], footerContent: react_1.default.createElement(_ui_1.Flex, null,
            react_1.default.createElement(_ui_1.Button, { style: _ui_1.Button.STYLES.OUTLINED, label: (0, util_1.t)('CLOSE'), onClick: close }),
            react_1.default.createElement(_ui_1.Spacing, { type: _ui_1.Spacing.TYPES.HORIZONTAL, size: _ui_1.Spacing.SIZES.SIZE_8 }),
            react_1.default.createElement(_ui_1.Button, { style: _ui_1.Button.STYLES.CONTAINED, label: updateQuery ? (0, util_1.t)('SAVE') : (0, util_1.t)('ADD'), onClick: handleSubmit(onSubmit), disabled: isAddDisabled })) },
        react_1.default.createElement("div", { className: 'ds-nfm-content' },
            !updateQuery && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(_ui_1.Flex, null,
                    react_1.default.createElement("div", { className: 'ds-nfm-col' },
                        react_1.default.createElement(_ui_1.Text, { type: _ui_1.Text.TYPES.BODY_MEDIUM, weight: _ui_1.Text.WEIGHTS.BOLD, text: (0, util_1.t)('NF_COMMUNICATED_TO') }),
                        react_1.default.createElement(_ui_1.Spacing, { type: _ui_1.Spacing.TYPES.VERTICAL, size: _ui_1.Spacing.SIZES.SIZE_4 }),
                        react_1.default.createElement(_ui_1.Dropdown, { label: null, singleSelect: true, size: _ui_1.Dropdown.SIZES.FULL_WIDTH, type: _ui_1.Dropdown.TYPES.VARIABLE, style: _ui_1.Dropdown.STYLES.LIGHT, options: optsAudienceBy, value: [optsAudienceBy.find((o) => o.value === audienceBy)].filter(Boolean), placeholder: (0, util_1.t)('NF_FOR_WHOM_TO_SEND'), onChange: (option) => {
                                audienceByCtrl.field.onChange(option.value);
                                checkedItemsCtrl.field.onChange([]);
                            } })),
                    audienceBy !== '' && audienceBy !== globals_1.GLOBAL_ALL_USERS && (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(_ui_1.Spacing, { type: _ui_1.Spacing.TYPES.HORIZONTAL, size: _ui_1.Spacing.SIZES.SIZE_12 }),
                        react_1.default.createElement("div", { className: 'ds-nfm-col' },
                            react_1.default.createElement(_ui_1.Text, { type: _ui_1.Text.TYPES.BODY_MEDIUM, weight: _ui_1.Text.WEIGHTS.BOLD, text: (0, util_1.t)('EMPLOYEES') }),
                            react_1.default.createElement(_ui_1.Spacing, { type: _ui_1.Spacing.TYPES.VERTICAL, size: _ui_1.Spacing.SIZES.SIZE_4 }),
                            audienceBy === globals_1.GLOBAL_DATEPICKER ? (react_1.default.createElement("div", { className: 'ds-news-feed-dt' },
                                react_1.default.createElement(_ui_1.DaySelect, {
                                    singleDaySelection: true,
                                    value: (0, moment_1.default)(),
                                    onChange: (val) => {
                                        checkedItemsCtrl.field.onChange(receiversMapper({
                                            audienceBy: globals_1.GLOBAL_DATEPICKER,
                                            values: val,
                                        }) || []);
                                    },
                                }),
                                react_1.default.createElement("span", null, checkedItems.length
                                    ? `${checkedItems.length} ${(0, util_1.t)('NF_EMPLOYEE_SELCTED')}`
                                    : (0, util_1.t)('NF_NO_EMPLOYEES')))) : (react_1.default.createElement(_ui_1.Dropdown, { label: null, searchable: true, size: _ui_1.Dropdown.SIZES.FULL_WIDTH, type: _ui_1.Dropdown.TYPES.VARIABLE, style: _ui_1.Dropdown.STYLES.LIGHT, options: optsCheckedItems, value: checkedItems.map((cb) => ({
                                    value: cb.id,
                                    label: cb.label,
                                })), placeholder: checkedItemsPlaceholder, onChange: (selected) => {
                                    checkedItemsCtrl.field.onChange(selected.map((s) => ({ id: s.value, label: s.label })));
                                } })))))),
                react_1.default.createElement(_ui_1.Spacing, { type: _ui_1.Spacing.TYPES.VERTICAL, size: _ui_1.Spacing.SIZES.SIZE_12 }))),
            react_1.default.createElement(_ui_1.Input, { size: _ui_1.Input.SIZES.FULL_WIDTH, type: _ui_1.Input.TYPES.TEXT, label: (0, util_1.t)('NF_SUBJECT'), placeholder: (0, maybe_unwrap_1.unwrapMaybe)((0, util_1.t)('NF_SUBJECT')), value: subjectCtrl.field.value, onChange: subjectCtrl.field.onChange }),
            react_1.default.createElement(_ui_1.Spacing, { type: _ui_1.Spacing.TYPES.VERTICAL, size: _ui_1.Spacing.SIZES.SIZE_12 }),
            react_1.default.createElement(_ui_1.Text, { type: _ui_1.Text.TYPES.BODY_MEDIUM, weight: _ui_1.Text.WEIGHTS.BOLD, text: (0, util_1.t)('NF_TEXTAREA_PLACEHOLDER') }),
            react_1.default.createElement(_ui_1.Spacing, { type: _ui_1.Spacing.TYPES.VERTICAL, size: _ui_1.Spacing.SIZES.SIZE_4 }),
            react_1.default.createElement(_ui_1.Textarea, { size: 'full-width', placeholder: (0, util_1.t)('NF_TEXTAREA_PLACEHOLDER'), value: textCtrl.field.value, onChange: textCtrl.field.onChange }),
            react_1.default.createElement(_ui_1.Spacing, { type: _ui_1.Spacing.TYPES.VERTICAL, size: _ui_1.Spacing.SIZES.SIZE_12 }),
            !updateQuery && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(_ui_1.Checkbox, { checked: requireConfirmationCtrl.field.value, onChange: requireConfirmationCtrl.field.onChange }, (0, util_1.t)('NF_CONFIRM_READING')),
                react_1.default.createElement(_ui_1.Spacing, { type: _ui_1.Spacing.TYPES.VERTICAL, size: _ui_1.Spacing.SIZES.SIZE_8 }))),
            react_1.default.createElement(_ui_1.Checkbox, { checked: pinAMessageCtrl.field.value, onChange: pinAMessageCtrl.field.onChange }, (0, util_1.t)('NF_PIN_A_MESSAGE')),
            react_1.default.createElement(_ui_1.Spacing, { type: _ui_1.Spacing.TYPES.VERTICAL, size: _ui_1.Spacing.SIZES.SIZE_16 }),
            react_1.default.createElement(_ui_1.Text, { type: _ui_1.Text.TYPES.BODY_MEDIUM, weight: _ui_1.Text.WEIGHTS.BOLD, text: (0, util_1.t)('NF_ATTACHMENTS') }),
            react_1.default.createElement(_ui_1.Spacing, { type: _ui_1.Spacing.TYPES.VERTICAL, size: _ui_1.Spacing.SIZES.SIZE_4 }),
            (() => {
                const DropFilesAny = manipulations_1.DropFiles;
                return (react_1.default.createElement(DropFilesAny, { loading: submitting, multiple: true, iconSize: null, accept: allowed_file_types_1.ALLOWED_FILES.map((item) => item.mime), onChange: (e) => setFiles([...e]) },
                    react_1.default.createElement("div", { className: 'ds-news-feed-files' },
                        react_1.default.createElement(_ui_1.Text, null, (0, util_1.t)('NF_DRAG_AND_DROP')))));
            })(),
            react_1.default.createElement("div", { className: 'ds-nf-allowed-files' },
                react_1.default.createElement("span", { className: 'ds-nf-allowed-files-title' }, (0, util_1.t)('NF_ALLOWED_FILE_TYPES') + ':'),
                react_1.default.createElement("div", { className: 'ds-nf-list-allowed-files-wrapper' },
                    react_1.default.createElement(_ui_1.Flex, null, allowed_file_types_1.ALLOWED_FILES.map((item, k) => (react_1.default.createElement(_ui_1.Icon, { key: k, ico: ('file-' + item.ext.toLowerCase()) })))))))));
};
exports.NewsFeedModal = NewsFeedModal;
